import React, { useEffect, useState } from "react";
import { Button, Glyphicon } from "react-bootstrap";
import { GROUP_TITLE_EN, GROUP_TITLE_RU, TITLE_EN, TITLE_RU } from "../../constants";
import FormControlLanguage from "../../../../UI/FormControlLanguage";

const RoleListItem = (
    {
        role,
        onEdit,
        onDelete,
    }
) => {
    const [model, setModel] = useState(null);
    const [isEditing, setEditing] = useState(false);

    useEffect(() => {
        isEditing && setModel(role);
    }, [isEditing]);

    const handleModelChange = (key, value) => {
        setModel({
            ...model,
            [key]: value,
        })
    };

    const handleModelEdit = () => {
        onEdit(model);
        setEditing(false);
    }

    return (
        <tr>
            <td>
                {isEditing
                    ? <FormControlLanguage
                            type="text"
                            values={{
                                ru: model?.[TITLE_RU] || '',
                                en: model?.[TITLE_EN] || '',
                            }}
                            onChange={{
                                ru: (e) => handleModelChange(TITLE_RU, e.target.value),
                                en: (e) => handleModelChange(TITLE_EN, e.target.value),
                            }}
                        />
                    : <span>
                        {role[TITLE_RU] || role[TITLE_EN]}
                    </span>
                }
            </td>
            <td>
                {isEditing
                    ? <FormControlLanguage
                            type="text"
                            values={{
                                ru: model?.[GROUP_TITLE_RU] || '',
                                en: model?.[GROUP_TITLE_EN] || '',
                            }}
                            onChange={{
                                ru: (e) => handleModelChange(GROUP_TITLE_RU, e.target.value),
                                en: (e) => handleModelChange(GROUP_TITLE_EN, e.target.value),
                            }}
                        />
                    : <span>
                        {role[GROUP_TITLE_RU] || role[GROUP_TITLE_EN]}
                    </span>
                }
            </td>
            <td>
                {isEditing
                    ? <Button onClick={handleModelEdit}>
                        <Glyphicon glyph="saved" />
                    </Button>
                    : <Button
                        onClick={() => setEditing(true)}
                    >
                        <Glyphicon glyph="pencil" />
                    </Button>
                }
                <Button onClick={() => onDelete(role.id)}>
                    <Glyphicon glyph="trash" />
                </Button>
            </td>
        </tr>
    );
};

export default RoleListItem;
